import React from 'react';
import './Horoscope.css';

export default function Horoscope({zodiac, image, title, description}) {
  return (
      <li>
        <h2 className="zodiac-symbol">{zodiac}</h2>
        <img src={image} alt={title}/>
        <h3>{title}</h3>
        <p>{description}</p>
      </li>
  );
}